/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import Modal from 'views/components/UI/Modal'
import { useNotification } from 'lib/context/notification.context'
import { tokenSelector } from 'ducks/user'
import Loader from 'views/components/UI/Loader'
// components
import {
  Container,
  Header,
  HeaderCard,
  HeaderIntro,
  ProcessBadge,
  ProcessBadgeLabel,
  ProcessBadgeValue,
  Body,
  GraphicsContainer,
  SubContainer,
  ContainerSelectCompetence,
  TypeGraphicContainer,
  CompetenceContainer,
  UsersContainer,
  NoDataContainer,
  NoDataText,
  NoDataIcon,
  NoDataSubContainer,
  TextContainer,
} from './styled'
import { H2, P } from 'views/components/UI/Text'
import Radar from 'views/components/Graphics/Radar'
import NineBox from 'views/components/Graphics/Ninebox'
import TeamMap from 'views/containers/TeamMap'
import HorizontalSelector from 'views/components/Selectors/HorizontalSelector'
import getCompetencesByProcess from 'services/competence/getCompetencesByProcess'
import getTestByProcess from 'services/competence/getTestByProcess'
import iconInfo from '../../../components/assets/iconInfo.png'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import InfoIcon from '@mui/icons-material/Info'
import useGetTextsNinebox from 'hooks/useGetNineboxTexts/use-get-ninebox-texts'
import MultiSelect from 'views/components/UI/SelectMultiple/select-multiple'
import getRadarData from 'services/competence/getRadarData'
import { optionsData } from './constants'
import getNineBoxAnalytics from 'services/competence/GetNineBoxAnalytics'
import { useTranslation } from 'react-i18next'

type AllProcess = {
  value: number
  label: string
  weight?: number
}

interface ValueLabel {
  [key: number]: string
}

export interface Score {
  mean: number
  skill_id: number
  users: UserScore[]
}

export interface UserScore {
  full_name: string
  competence_score: number
  user_id: number
}

const Analytics = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { getError } = useNotification()
  const { getWarning } = useNotification()
  const { textsNinebox } = useGetTextsNinebox('potencial')
  const initialProcessId = location.state?.processId ? String(location.state.processId) : ''
  const initialProcessName = location.state?.processName || ''

  const token = useSelector(tokenSelector)

  const [checks, setChecks] = useState({ betesa: false, competences: false })
  const [isTestsLoading, setIsTestsLoading] = useState<boolean>(Boolean(initialProcessId))
  const [isCompetenceDataLoading, setIsCompetenceDataLoading] = useState<boolean>(Boolean(initialProcessId))
  const [isChecksLoading, setIsChecksLoading] = useState<boolean>(Boolean(initialProcessId))
  const [isRadarLoading, setIsRadarLoading] = useState<boolean>(false)

  const [selectedProcess] = useState<string>(initialProcessId)
  const [processName] = useState<string>(initialProcessName)
  const [selectedGraphic, setSelectedGraphic] = useState<string>('1')
  // Radar state
  const [competences, setCompetences] = useState<AllProcess[]>([])
  const [users, setUsers] = useState<AllProcess[]>([])
  const [selectedCompetence, setSelectedCompetence] = useState<any>([])
  const [selectedUsers, setSelectedUsers] = useState<any>([])
  const [testIds, setTestIds] = useState({ competenceId: '', betesaId: '' })
  const [resultData, setResultData] = useState<Score[]>([])
  const [radarLabels, setRadarLabels] = useState<string[]>([])
  const [idealProfileData, setIdealProfileData] = useState<number[]>([])
  const [hasInitializedRadarSelection, setHasInitializedRadarSelection] = useState(false)
  const latestRadarRequestId = useRef(0)
  // Modal state
  const [showModal, setShowModal] = useState<boolean>(false)

  useEffect(() => {
    if (selectedProcess === '') return
    setIsTestsLoading(true)
    setIsCompetenceDataLoading(true)
    setTestIds({ competenceId: '', betesaId: '' })

    getTestByProcess(Number(selectedProcess)).then(
      ({ data }: any) => {
        if (data && data.length > 0) {
          let competenceId = ''
          let betesaId = ''

          data.forEach((item: any) => {
            if (item.name.startsWith('Competencias')) {
              competenceId = item.id
            } else if (item.name.startsWith('Betesa')) {
              betesaId = item.id
            }
          })

          setTestIds({ competenceId, betesaId })
        } else {
          setIsCompetenceDataLoading(false)
        }
      },
      (error) => {
        console.error('Error buscando las pruebas: ', error)
        getError('Ha ocurrido un error al cargar las pruebas')
        setIsCompetenceDataLoading(false)
      }
    ).finally(() => {
      setIsTestsLoading(false)
    })
  }, [selectedProcess])

  useEffect(() => {
    if (selectedProcess === '') {
      return
    }

    if (testIds.competenceId.length === 0) {
      if (!isTestsLoading) {
        setIsCompetenceDataLoading(false)
      }
      return
    }

    setIsCompetenceDataLoading(true)

    getCompetencesByProcess(Number(testIds.competenceId)).then(
      ({ data }: any) => {
        if (data) {
          const competencesFormatted = data.listCompetence.map((competenceItem: any) => ({
            value: competenceItem.competenceId,
            label: competenceItem.skill,
            weight: competenceItem.weight,
          }))
          const usersFormatted = data.listUsers.map((userItem: any) => ({
            value: userItem.userId,
            label: `${userItem.first_name} ${userItem.last_name}`,
          }))
          setCompetences(competencesFormatted)
          setUsers([{ value: 0, label: 'Todos' }, ...usersFormatted])
          setHasInitializedRadarSelection(false)
        }
      },
      (error) => {
        console.error('Error buscando las competencias: ', error)
        getError('Ha ocurrido un error al cargar las competencias')
        setTestIds((prevState) => ({ ...prevState, competenceId: '' }))
      }
    ).finally(() => {
      setIsCompetenceDataLoading(false)
    })
  }, [isTestsLoading, selectedProcess, testIds.competenceId])

  useEffect(() => {
    if (
      selectedProcess === '' ||
      !testIds.competenceId ||
      selectedCompetence.length === 0 ||
      selectedUsers.length === 0
    ) {
      setResultData([])
      setRadarLabels([])
      return
    }

    setIsRadarLoading(true)
    const selectedUsersFiltered = selectedUsers.filter((user: number) => user !== 0)
    const requestId = latestRadarRequestId.current + 1
    latestRadarRequestId.current = requestId

    getRadarData(Number(testIds.competenceId), selectedUsersFiltered, selectedCompetence).then(
      ({ data }: any) => {
        if (requestId !== latestRadarRequestId.current) {
          return
        }

        if (data && data.overall_score && data.overall_score.length > 0) {
          setResultData(data.overall_score)
          const valueLabelMap: ValueLabel = competences.reduce<ValueLabel>((acc, item) => {
            acc[item.value] = item.label
            return acc
          }, {})
          setRadarLabels(data.overall_score.map((item: any) => valueLabelMap[item.skill_id]))

          const answeredUsers = new Set<number>()
          data.overall_score.forEach((item: any) => {
            item.users?.forEach((user: UserScore) => answeredUsers.add(user.user_id))
          })

          if (selectedUsersFiltered.some((userId: number) => !answeredUsers.has(userId))) {
            getWarning('Seleccionaste usuarios que no han contestado la prueba')
          }
        } else {
          setResultData([])
          setRadarLabels([])
        }
      },
      (error) => {
        if (requestId !== latestRadarRequestId.current) {
          return
        }
        console.error('Error buscando los datos del radar: ', error)
        getError('Ha ocurrido un error al cargar los datos del radar')
      }
    ).finally(() => {
      if (requestId === latestRadarRequestId.current) {
        setIsRadarLoading(false)
      }
    })
  }, [selectedProcess, selectedCompetence, selectedUsers, token, testIds, competences])

  useEffect(() => {
    if (selectedCompetence.length === 0) {
      setIdealProfileData([])
      return
    }

    setIdealProfileData(
      selectedCompetence.map((id: number) => {
        const competencesWeight = competences.find((competence) => competence.value === id)
        return competencesWeight ? competencesWeight.weight : null
      })
    )
  }, [competences, selectedCompetence])

  useEffect(() => {
    if (selectedProcess === '') {
      return
    }
    setIsChecksLoading(true)
    const body = {
      process_id: Number(selectedProcess),
      is_betesa: true,
      is_competences: true,
      career_plan: false,
    }

    getNineBoxAnalytics(body).then(
      ({ data }: any) => {
        if (data) {
          setChecks({ betesa: !!data.betesa_ideal_profile, competences: !!data.competences_ideal_profile })
        }
      },
      (error) => {
        console.error('Error buscando los datos del ninebox: ', error)
      }
    ).finally(() => {
      setIsChecksLoading(false)
    })
  }, [selectedProcess])

  useEffect(() => {
    if (hasInitializedRadarSelection || competences.length === 0 || users.length <= 1) {
      return
    }

    setSelectedCompetence(competences.map((competence) => competence.value))
    setSelectedUsers(users.filter((user) => user.value !== 0).map((user) => user.value))
    setHasInitializedRadarSelection(true)
  }, [competences, users, hasInitializedRadarSelection])

  const handleCompetenceChange = (value: any) => {
    setSelectedCompetence(value)
  }

  const handleSelectUsers = (newValues: any) => {
    const allUserIds = users.filter((user) => user.value !== 0).map((user) => user.value)

    if (newValues.includes(0)) {
      setSelectedUsers(allUserIds)
      return
    }

    setSelectedUsers(newValues.filter((value: number) => value !== 0))
  }

  const BlueTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#2bb5d4',
      color: 'white',
      boxShadow: theme.shadows[2],
      fontSize: 14,
    },
  }))

  const userResultData = JSON.parse(JSON.stringify(resultData))
  const idealProfileRadarData = JSON.parse(JSON.stringify(idealProfileData))
  const allSelectableUserIds = users.filter((user) => user.value !== 0).map((user) => user.value)
  const areAllCompetencesSelected = competences.length > 0 && selectedCompetence.length === competences.length
  const areAllUsersSelected = allSelectableUserIds.length > 0 && selectedUsers.length === allSelectableUserIds.length
  const renderLoader = (text = 'Cargando analíticas...') => (
    <SubContainer width="100%" alignItems="center" justifyContent="center" style={{ padding: '40px 0' }}>
      <Loader text={text} />
    </SubContainer>
  )

  return (
    <MainLayout>
      <Container>
        <Header>
          <HeaderCard>
            <HeaderIntro>
              <H2 marginBottom="0px">Analíticas</H2>
              <P margin="0px" color="#647789" fontSize="15px">
                Explora los resultados y mapas del proceso seleccionado.
              </P>
            </HeaderIntro>
            {initialProcessId ? (
              <ProcessBadge>
                <ProcessBadgeLabel>Proceso</ProcessBadgeLabel>
                <ProcessBadgeValue>{processName}</ProcessBadgeValue>
              </ProcessBadge>
            ) : null}
          </HeaderCard>
        </Header>

        {!initialProcessId && (
          <Body>
            <NoDataContainer style={{ width: '100%', height: 'auto', minHeight: '72px', marginTop: '24px' }}>
              <NoDataSubContainer style={{ justifyContent: 'center' }}>
                <TextContainer>
                  <NoDataText style={{ textAlign: 'center' }}>
                    Para acceder a las Analíticas, ve al proceso correspondiente y encuentra el botón "Ver analíticas".
                  </NoDataText>
                </TextContainer>
              </NoDataSubContainer>
            </NoDataContainer>
          </Body>
        )}

        {selectedProcess !== '' && (
          <Body>
            <HorizontalSelector
              items={optionsData}
              setSelected={(e) => setSelectedGraphic(e)}
              selected={selectedGraphic}
              appearance="segmented"
            />

            <GraphicsContainer>
              {selectedGraphic === '1' && (
                <SubContainer width="100%">
                  {isTestsLoading || isCompetenceDataLoading ? (
                    renderLoader('Cargando datos de 3D Skills...')
                  ) : competences && competences.length > 0 ? (
                    <>
                      <ContainerSelectCompetence>
                        <CompetenceContainer>
                          <div
                            style={{
                              marginTop: '13px',
                              display: 'flex',
                            }}
                          >
                            <P fontWeight={600}>{t('global.common.skillText')}:</P>
                            <div style={{ marginTop: '5px', marginRight: '5px', marginLeft: '5px' }}>
                              <BlueTooltip title="Se cargan por defecto todas las competencias del proceso. Puedes desmarcar las que no quieras incluir en la gráfica. Esta visual admite entre 3 y 10 competencias.">
                                <InfoIcon
                                  style={{
                                    color: '#2BB5D4',
                                    width: '14px',
                                    height: '14px',
                                    cursor: 'pointer',
                                  }}
                                />
                              </BlueTooltip>
                            </div>
                          </div>
                          <div style={{ width: '50%' }}>
                            <MultiSelect
                              noChip={true}
                              width="300px"
                              label="Competencias visibles"
                              options={competences}
                              value={selectedCompetence}
                              onChange={handleCompetenceChange}
                              limitTags={1}
                            />
                          </div>
                        </CompetenceContainer>
                        <UsersContainer>
                          <div
                            style={{
                              marginTop: '13px',
                            }}
                          >
                            <P fontWeight={600}>Usuarios:</P>
                          </div>
                          <div style={{ width: '50%', marginLeft: '25px', maxHeight: '50px' }}>
                            <MultiSelect
                              noChip={true}
                              width="300px"
                              label="Usuarios visibles"
                              options={users}
                              value={selectedUsers}
                              onChange={handleSelectUsers}
                              limitTags={1}
                            />
                          </div>
                        </UsersContainer>
                      </ContainerSelectCompetence>
                      {areAllCompetencesSelected || areAllUsersSelected ? (
                        <div
                          style={{
                            width: '100%',
                            margin: '-12px 0 18px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'inline-flex',
                              flexWrap: 'wrap',
                              justifyContent: 'center',
                              gap: '8px',
                              padding: '10px 16px',
                              borderRadius: '999px',
                              background: 'rgba(45, 116, 156, 0.08)',
                              border: '1px solid rgba(45, 116, 156, 0.14)',
                              color: '#365066',
                              fontSize: '13px',
                              fontWeight: 600,
                              textAlign: 'center',
                            }}
                          >
                            {areAllCompetencesSelected ? 'Incluyendo todas las competencias del proceso.' : null}
                            {areAllCompetencesSelected && areAllUsersSelected ? ' ' : null}
                            {areAllUsersSelected ? 'Incluyendo todos los usuarios seleccionables del proceso.' : null}
                          </div>
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <NoDataContainer>
                      <NoDataSubContainer>
                        <NoDataIcon src={iconInfo} />
                        <TextContainer>
                          <NoDataText>No hay datos de {t('global.common.skillText')} en este proceso</NoDataText>
                        </TextContainer>
                      </NoDataSubContainer>
                    </NoDataContainer>
                  )}

                  <TypeGraphicContainer>
                    {isRadarLoading ? (
                      renderLoader('Cargando gráfica de 3D Skills...')
                    ) : resultData.length &&
                    resultData.some((item) => item.users.length > 0) &&
                    selectedCompetence.length >= 3 &&
                    selectedUsers.length ? (
                      <SubContainer width="100%" margin="0 auto">
                        <Radar
                          userResultData={userResultData}
                          userResultLabels={radarLabels}
                          idealProfileData={idealProfileRadarData}
                        />
                      </SubContainer>
                    ) : selectedCompetence.length >= 3 &&
                      selectedUsers.length &&
                      (!resultData.length || resultData.every((item) => item.users.length === 0)) ? (
                      <NoDataContainer>
                        <NoDataSubContainer>
                          <NoDataIcon src={iconInfo} />
                          <TextContainer>
                            <NoDataText>Los usuarios que seleccionaste no han contestado la prueba</NoDataText>
                          </TextContainer>
                        </NoDataSubContainer>
                      </NoDataContainer>
                    ) : selectedUsers.length && selectedCompetence.length > 0 && selectedCompetence.length < 3 ? (
                      <NoDataContainer>
                        <NoDataSubContainer>
                          <NoDataIcon src={iconInfo} />
                          <TextContainer>
                            <NoDataText>Selecciona al menos 3 competencias para generar la gráfica</NoDataText>
                          </TextContainer>
                        </NoDataSubContainer>
                      </NoDataContainer>
                    ) : selectedUsers.length && selectedCompetence.length === 0 ? (
                      <NoDataContainer>
                        <NoDataSubContainer>
                          <NoDataIcon src={iconInfo} />
                          <TextContainer>
                            <NoDataText>Selecciona al menos una competencia para generar la gráfica</NoDataText>
                          </TextContainer>
                        </NoDataSubContainer>
                      </NoDataContainer>
                    ) : null}
                  </TypeGraphicContainer>
                </SubContainer>
              )}

              {selectedGraphic === '2' && (
                <SubContainer justifyContent="center" alignItems="center">
                  {isTestsLoading ? renderLoader('Cargando mapa Betesa...') : <TeamMap betesaId={testIds.betesaId} processId={selectedProcess} />}
                </SubContainer>
              )}

              {selectedGraphic === '3' && (
                <TypeGraphicContainer style={{ marginTop: '0' }}>
                  <SubContainer height="130%" padding="0% 0%">
                    {isChecksLoading ? (
                      renderLoader('Cargando 9Box...')
                    ) : (
                      <NineBox
                        processId={selectedProcess}
                        checksIdeal={checks}
                        processName={processName}
                        textsNinebox={textsNinebox || []}
                      />
                    )}
                  </SubContainer>
                </TypeGraphicContainer>
              )}
            </GraphicsContainer>
          </Body>
        )}
        <Modal
          show={showModal}
          setShow={setShowModal}
          styleContent={{
            width: '80%',
          }}
        >
          <div>
            <H2>Modal</H2>
            <P>Modal contenido</P>
          </div>
        </Modal>
      </Container>
    </MainLayout>
  )
}

export default Analytics
